import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F93s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      herramienta_digital: "CORREO ELECTRÓNICO OFICIAL",
      tipo_de_informacion_contenida: "PÚBLICA",
      tipo_de_usuario: "SUPER USUARIO",
      nombre_de_la_herramienta_digital: "",
      descripcion: "",
      hipervinculo: "",
      nombre_del_usuario: "",
      contrasena: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f93s: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F93/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f93s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/93/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      herramienta_digital: "CORREO ELECTRÓNICO OFICIAL",
      tipo_de_informacion_contenida: "PÚBLICA",
      tipo_de_usuario: "SUPER USUARIO",
      nombre_de_la_herramienta_digital: "",
      descripcion: "",
      hipervinculo: "",
      nombre_del_usuario: "",
      contrasena: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      herramienta_digital: row.herramienta_digital,
      tipo_de_informacion_contenida: row.tipo_de_informacion_contenida,
      tipo_de_usuario: row.tipo_de_usuario,
      nombre_de_la_herramienta_digital: row.nombre_de_la_herramienta_digital,
      descripcion: row.descripcion,
      hipervinculo: row.hipervinculo,
      nombre_del_usuario: row.nombre_del_usuario,
      contrasena: row.contrasena,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      herramienta_digital: row.herramienta_digital,
      tipo_de_informacion_contenida: row.tipo_de_informacion_contenida,
      tipo_de_usuario: row.tipo_de_usuario,
      nombre_de_la_herramienta_digital: row.nombre_de_la_herramienta_digital,
      descripcion: row.descripcion,
      hipervinculo: row.hipervinculo,
      nombre_del_usuario: row.nombre_del_usuario,
      contrasena: row.contrasena,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      herramienta_digital: row.herramienta_digital,
      tipo_de_informacion_contenida: row.tipo_de_informacion_contenida,
      tipo_de_usuario: row.tipo_de_usuario,
      nombre_de_la_herramienta_digital: row.nombre_de_la_herramienta_digital,
      descripcion: row.descripcion,
      hipervinculo: row.hipervinculo,
      nombre_del_usuario: row.nombre_del_usuario,
      contrasena: row.contrasena,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      herramienta_digital: this.state.herramienta_digital,
      tipo_de_informacion_contenida: this.state.tipo_de_informacion_contenida,
      tipo_de_usuario: this.state.tipo_de_usuario,
      nombre_de_la_herramienta_digital: this.state.nombre_de_la_herramienta_digital,
      descripcion: this.state.descripcion,
      hipervinculo: this.state.hipervinculo,
      nombre_del_usuario: this.state.nombre_del_usuario,
      contrasena: this.state.contrasena,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F93", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      herramienta_digital: this.state.herramienta_digital,
      tipo_de_informacion_contenida: this.state.tipo_de_informacion_contenida,
      tipo_de_usuario: this.state.tipo_de_usuario,
      nombre_de_la_herramienta_digital: this.state.nombre_de_la_herramienta_digital,
      descripcion: this.state.descripcion,
      hipervinculo: this.state.hipervinculo,
      nombre_del_usuario: this.state.nombre_del_usuario,
      contrasena: this.state.contrasena,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F93/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F93/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeHerramientaDigital = e => {
    this.setState({ herramienta_digital: e.target.value });
  };

  onChangeTipoDeInformacionContenida = e => {
    this.setState({ tipo_de_informacion_contenida: e.target.value });
  };

  onChangeTipoDeUsuario = e => {
    this.setState({ tipo_de_usuario: e.target.value });
  };

  onChangeNombreDeLaHerramientaDigital = e => {
    this.setState({ nombre_de_la_herramienta_digital: e.target.value });
  };

  onChangeDescripcion = e => {
    this.setState({ descripcion: e.target.value });
  };

  onChangeHipervinculo = e => {
    this.setState({ hipervinculo: e.target.value });
  };

  onChangeNombreDelUsuario = e => {
    this.setState({ nombre_del_usuario: e.target.value });
  };

  onChangeContrasena = e => {
    this.setState({ contrasena: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };



  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"93"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "herramienta_digital",
        text: "Herramienta Digital",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "tipo_de_informacion_contenida",
        text: "Tipo De Informacion Contenida",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "tipo_de_usuario",
        text: "Tipo De Usuario",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "nombre_de_la_herramienta_digital",
        text: "Nombre De La Herramienta Digital",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "descripcion",
        text: "Descripcion",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "hipervinculo",
        text: "Hipervinculo",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "nombre_del_usuario",
        text: "Nombre Del Usuario",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "contrasena",
        text: "Contraseña",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">CORREOS ELECTRÓNICOS, PLATAFORMAS Y SISTEMAS DIGITALES</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 93 referente
                a correos electrónicos, plataformas y sistemas digitales, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f93s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="93" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=93"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Herramienta Digital:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  as="select"
                  custom
                  type="text"
                  name="herramienta_digital"
                  value={this.state.herramienta_digital}
                  onChange={this.onChangeHerramientaDigital}
                >
                  <option>CORREO ELECTRÓNICO OFICIAL</option>
                  <option>CORREO ELECTRÓNICO COMERCIAL</option>
                  <option>PLATAFORMA DIGITAL</option>
                  <option>SISTEMA DIGITAL</option>
                </Form.Control>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Tipo De Informacion Contenida:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  as="select"
                  custom
                  type="text"
                  name="tipo_de_informacion_contenida"
                  value={this.state.tipo_de_informacion_contenida}
                  onChange={this.onChangeTipoDeInformacionContenida}
                >
                  <option>PÚBLICA</option>
                  <option>CONFIDENCIAL</option>
                  <option>RESERVADA</option>
                  <option>MIXTA</option>
                </Form.Control>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Tipo De Usuario:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  as="select"
                  custom
                  type="text"
                  name="tipo_de_usuario"
                  value={this.state.tipo_de_usuario}
                  onChange={this.onChangeTipoDeUsuario}
                >
                  <option>SUPER USUARIO</option>
                  <option>ADMINISTRADOR</option>
                  <option>OPERATIVO</option>
                  <option>DE CONSULTA</option>
                </Form.Control>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Nombre De La Herramienta Digital:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nombre_de_la_herramienta_digital"
                  value={this.state.nombre_de_la_herramienta_digital}
                  onChange={this.onChangeNombreDeLaHerramientaDigital}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Descripcion:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="descripcion"
                  value={this.state.descripcion}
                  onChange={this.onChangeDescripcion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Hipervínculo A La Página De Acceso O IP De Acceso:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="hipervinculo"
                  value={this.state.hipervinculo}
                  onChange={this.onChangeHipervinculo}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Nombre Del Usuario:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nombre_del_usuario"
                  value={this.state.nombre_del_usuario}
                  onChange={this.onChangeNombreDelUsuario}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Contraseña:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="contrasena"
                  value={this.state.contrasena}
                  onChange={this.onChangeContrasena}
                />
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} className="btn-ejecutar" disabled={this.state.noEdit} >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Herramienta Digital:
                    </Col>
                    <Col xs={10}>{this.state.herramienta_digital}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Tipo De Informacion Contenida:
                    </Col>
                    <Col xs={10}>{this.state.tipo_de_informacion_contenida}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Tipo De Usuario:
                    </Col>
                    <Col xs={10}>{this.state.tipo_de_usuario}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Nombre De La Herramienta Digital:
                    </Col>
                    <Col xs={10}>{this.state.nombre_de_la_herramienta_digital}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Descripcion:
                    </Col>
                    <Col xs={10}>{this.state.descripcion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Hipervínculo A La Página De Acceso O IP De Acceso:
                    </Col>
                    <Col xs={10}>{this.state.hipervinculo}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Nombre Del Usuario:
                    </Col>
                    <Col xs={10}>{this.state.nombre_del_usuario}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Contraseña:
                    </Col>
                    <Col xs={10}>{this.state.contrasena}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>

                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F93s;
